import { Injectable } from '@angular/core';
import { FlexJointFields } from 'src/app/modules/dashboard/sheet/modules/steps/modules/accessories/flex-joint/flex-joint-fields';
import { GlobalFields } from 'src/app/modules/dashboard/sheet/modules/steps/modules/global/global-fields';
import { CableFields } from 'src/app/modules/dashboard/sheet/modules/steps/modules/pipe-properties/cable/cable-fields';
import { ConnectorFields } from 'src/app/modules/dashboard/sheet/modules/steps/modules/pipe-properties/connector/connector-fields';
import { FlexLineGeneralFields } from 'src/app/modules/dashboard/sheet/modules/steps/modules/pipe-properties/flex-line/components/general/general-fields';
import { FlexLineUtilizationFactorFields } from 'src/app/modules/dashboard/sheet/modules/steps/modules/pipe-properties/flex-line/components/utilization-factor/utilization-factor-fields';
import { RigidTubeCoatingFields } from 'src/app/modules/dashboard/sheet/modules/steps/modules/pipe-properties/rigid-tube/components/coating/coating-fields';
import { RigidTubeGeneralFields } from 'src/app/modules/dashboard/sheet/modules/steps/modules/pipe-properties/rigid-tube/components/general/general-fields';
import { RigidTubeUtilizationFactorFields } from 'src/app/modules/dashboard/sheet/modules/steps/modules/pipe-properties/rigid-tube/components/utilization-factor/utilization-factor-fields';
import { SoilsFields } from 'src/app/modules/dashboard/sheet/modules/steps/modules/soils/soils-fields';
import { Clone } from 'src/app/shared/utils/clone';
import { CONSTANTS } from '../../../core/constants/constants';
import { EnvironmentPropsService } from '../../../core/services/environment-props/environment-props.service';
import { RemoveProperty } from '../remove-property/remove-property';

@Injectable()
export class JsonCleanerService {
  propertiesMap = new Map();
  objectsBypass: string[];
  latestObjectStr = '';
  latestReturn = null;
  anflexWeb: boolean;

  unecessaryProps = new Set([CONSTANTS.ID, CONSTANTS.GRAPHIC_PROPERTIES]);

  makeCopy(obj): any {
    const data = Clone(obj);
    if (!data.hasOwnProperty('internalId')) {
      data.internalId = '';
    }
    return data;
  }

  constructor(private environmentPropsService: EnvironmentPropsService) {
    this.anflexWeb = this.environmentPropsService.isAnflex;
    this.propertiesMap.set(CONSTANTS.GLOBAL, this.makeCopy(GlobalFields.controls));
    this.propertiesMap.set(
      CONSTANTS.MATERIAL_TYPES.FLEX_LINE,
      this.makeCopy(
        Object.assign(
          { title: { quantity: null } },
          {
            ...FlexLineGeneralFields.controls,
            utilizationFactor: { ...FlexLineUtilizationFactorFields.controls },
          },
        ),
      ),
    );
    this.propertiesMap.set(CONSTANTS.MATERIAL_TYPES.CABLE, this.makeCopy(CableFields.controls));
    this.propertiesMap.set(
      CONSTANTS.MATERIAL_TYPES.RIGID_TUBE,
      this.makeCopy(
        Object.assign(
          { title: { quantity: null } },
          {
            ...RigidTubeGeneralFields.controls,
            ...RigidTubeCoatingFields.controls,
            utilizationFactor: { ...RigidTubeUtilizationFactorFields.controls },
          },
        ),
      ),
    );
    this.propertiesMap.get(CONSTANTS.MATERIAL_TYPES.RIGID_TUBE).coating = '';
    this.propertiesMap.get(CONSTANTS.MATERIAL_TYPES.RIGID_TUBE).internalCoating = '';
    this.propertiesMap.set(
      CONSTANTS.MATERIAL_TYPES.CONNECTOR,
      this.makeCopy(ConnectorFields.controls),
    );
    this.propertiesMap.set(
      CONSTANTS.ACCESSORY_TYPES.FLEXJOINT,
      this.makeCopy(FlexJointFields.controls),
    );
    this.propertiesMap.get(CONSTANTS.ACCESSORY_TYPES.FLEXJOINT).stiffDynamicBending = '';
    this.propertiesMap.set(CONSTANTS.SOIL, this.makeCopy(SoilsFields.controls));
    this.objectsBypass = [
      CONSTANTS.LINE_BINDING_TYPES.FLOATING,
      CONSTANTS.LINE_BINDING_TYPES.CONNECTION,
    ];
  }

  cleanObjectFields(object: any, allowedFields: Set<string>): void {
    if (!(object instanceof Object)) {
      return object;
    }

    Object.keys(object).forEach((key) => {
      if (!allowedFields.has(key)) {
        delete object[key];
      }
    });
  }

  cleanJson(inputJson: any): any {
    RemoveProperty(inputJson, this.unecessaryProps);

    if (this.anflexWeb) {
      return inputJson;
    }

    if (inputJson === null) {
      return null;
    }

    const inputStr = JSON.stringify(inputJson);
    if (inputStr === this.latestObjectStr) {
      return this.latestReturn;
    }

    this.latestObjectStr = JSON.stringify(inputJson);

    Object.keys(inputJson).forEach((key) => {
      if (
        this.propertiesMap.has(key) &&
        inputJson[key] instanceof Array &&
        !this.objectsBypass.includes(key)
      ) {
        const allowedProperties = new Set<string>(Object.keys(this.propertiesMap.get(key)));

        for (const obj of inputJson[key]) {
          this.cleanObjectFields(obj, allowedProperties);
        }
      }
    });

    if (inputJson?.global?.length) {
      inputJson.global = inputJson.global[0];
    }

    this.latestReturn = inputJson;

    return inputJson;
  }
}
